module.exports = __webpack_public_path__ + "img/newwhite.5976dfa7.svg";